import MobileMap from "@/components/AnimatedMap/MobileMap";
import { useMemo } from "react";
import { mobileMapSizes, mobileSizes, style, transitionOptions } from "./mockData";
import { getSize } from "../../utils";
import { animated, useSpring } from "react-spring";
import map_url from "@/assets/images/home/map.png"
import { getOptions } from "./utils";
import { Box, CardMedia, useMediaQuery } from "@mui/material";
import MobileModal from "./components/MobileModal";
import AnimatedSlider from "./components/AnimatedSlider";

const AnimatedMobileMap = () => {
  const isMobile = useMediaQuery("(max-width: 681px)");
  const isLargeDesktop = useMediaQuery("(max-width: 1679px)");
  const mobileSize = useMemo(
    () => {
      if (isMobile) {
        return mobileSizes.xs;
      };
      if (isLargeDesktop) {
        return mobileSizes.lg;
      };
      return mobileSizes.xl;
    },
    [isMobile, isLargeDesktop]
  );
  const mobileMapSize = useMemo(
    () => {
      if (isMobile) {
        return mobileMapSizes.xs;
      };
      if (isLargeDesktop) {
        return mobileMapSizes.lg;
      };
      return mobileMapSizes.xl;
    },
    [isLargeDesktop, isMobile]
  );
  const styles = useMemo(
    () => {
      if (isMobile) {
        return style.xs;
      };
      if (isLargeDesktop) {
        return style.lg;
      };
      return style.xl;
    },
    [isLargeDesktop, isMobile]
  );
  const options = useMemo(() => {
    const getWidth = getSize(mobileMapSizes.xl.width / mobileMapSize.width);
    const getHeight = getSize(mobileMapSizes.xl.height / mobileMapSize.height);
    return getOptions(getWidth, getHeight);
  }, [mobileMapSize]);

  const [animatedStyles] = useSpring(() => transitionOptions, []);

  const Animated = animated((props) => (
    <MobileMap
      {...props}
      sx={{
        ...mobileSize,
        padding: `${mobileSize.padding}px`,
        ...styles.container
      }}
    >
      <MobileModal />
      <Box
        sx={{
          position: "absolute",
          borderRadius: "12px",
          backgroundColor: "#47B4E3",
          zIndex: "2",
          ...options.icon,
          ...styles.icon
        }}
      />
      <CardMedia
        component="img"
        image={map_url}
        sx={{
          position: "absolute",
          width: mobileMapSize.width,
          height: mobileMapSize.height,
          ...options.map,
        }}
      />
      <AnimatedSlider />
    </MobileMap>
  ));

  return (
    <Animated style={animatedStyles} />
  );
};

export default AnimatedMobileMap;